<template>
  <div>
    <generic-container
      :title="$t('assignation distribution')"
      icon="school"
      :show_plus="true"
      :show_back="true"
      v-on:add="add"
      :header_buttons="header_buttons"
    >
      <h2 class="ui dividing header">
        <i class="school icon"></i>
        <div class="content">
          {{ assignation.name }}
          <div class="sub header">
            {{ $t("from") }}
            <strong>{{
              assignation.start_date
                | formatDate(enterprise_setup.simple_date_format)
            }}</strong>
            {{ $t("to") }}
            <strong>{{
              assignation.end_date
                | formatDate(enterprise_setup.simple_date_format)
            }}</strong>
          </div>
        </div>
      </h2>
      <course-based
        v-show="method == 'course'"
        ref="course_based"
        @set_assignation="set_assignation"
      />
      <professor-based
        v-show="method == 'teacher'"
        ref="professor_based"
        :season="assignation"
      />
    </generic-container>
    <preinscription-modal ref="preinscription_modal" />
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import PreinscriptionModal from "@/modules/course_assignation/preinscription_modal/Index";
import {
  local_api,
  error_toast,
  // success_toast,
  enterprise_setup,
} from "@/utils";
// import { Container, Draggable } from "vue-dndrop";
// import draggable from "vuedraggable";
// import { cloneDeep } from "lodash";
import CourseBased from "@/modules/course_assignation/distribution/course_based/CourseAssignationDistributionCourseBasedIndex";
import ProfessorBased from "@/modules/course_assignation/distribution/professor_based/CourseAssignationDistributionProfessorBasedIndex";

// @ is an alias to /src
export default {
  name: "CourseAssignationDistribution",
  components: {
    "generic-container": GenericContainer,
    PreinscriptionModal,
    CourseBased,
    ProfessorBased,
    // Container,
    // Draggable,
    // draggable,
  },
  filters: filters,
  data() {
    return {
      // show_presinscription_modal: false,
      assignation: { setup: {} },
      header_buttons: [
        // {
        //   icon: "refresh",
        //   tooltip: this.$t("refresh"),
        //   click: this.init,
        // },
        // {
        //   icon: "blue save",
        //   tooltip: this.$t("save"),
        //   click: this.save,
        // },
      ],
      method: "",
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.preinscription_modal.show_modal({
        season_id: vm.assignation.season_id,
      });
      // this.preinscription_modals.push(PreinscriptionModal);
      // vm.show_presinscription_modal = true;
      // setTimeout(() => {
      //   vm.$refs.preinscription_modal.setData({
      //     courses: vm.assignation.setup.courses,
      //     season_id: vm.assignation.season_id,
      //   });
      // }, 300);
    },
    init() {
      let vm = this;
      if (vm.method == "course") {
        vm.$refs.course_based.init();
      }
      // let distribution_uuid = this.$route.query.i;
      // if (distribution_uuid) {
      //   local_api(vm, "post", "/course/assignation/do-get", {
      //     u: distribution_uuid,
      //   })
      //     .then((assignation) => {
      //       vm.assignation = assignation;
      //       // if (assignation && assignation.setup && assignation.setup.courses) {
      //       if (assignation && assignation.distinctCourses) {
      //         let ordered = assignation.distinctCourses.sort((a, b) => {
      //           return a.name.localeCompare(b.name);
      //           // if (a.name > b.name) return 1;
      //           // else if (a.name < b.name) return -1;
      //           // else return 0;
      //         });
      //         assignation.setup.courses = ordered;
      //       }
      //     })
      //     .catch((err) => {
      //       error_toast(err);
      //     });
      // } else {
      //   error_toast(this.$t("no course distribution found"));
      // }
    },
    // save() {
    //   let vm = this;

    //   let courses = vm.courses.map((c) => {
    //     return {
    //       course_id: c.course_id,
    //       preinscribed: c.preinscribed,
    //       sections: c.sections,
    //     };
    //   });

    //   local_api(vm, "post", "/course/assignation/do-save-distribution", {
    //     s: vm.assignation.season_id,
    //     c: courses,
    //   })
    //     .then((/* rdist */) => {
    //       success_toast(vm.$t("distribution saved"));
    //     })
    //     .catch((err) => {
    //       error_toast(err);
    //     });
    // },
    set_assignation(assignation) {
      this.assignation = assignation;
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();

    /**
     * Get course assignation module configuration
     */
    local_api(vm, "post", "/course/assignation/do-get-configuration", {})
      .then((r) => {
        if (r && r.conf && r.conf.setup) {
          if (r.conf.setup.method) {
            vm.method = r.conf.setup.method;
          }
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    /**
     * Get careers and branches
     */
    local_api(vm, "post", "/student_configuration/do-get-configuration", {})
      .then((studentConfiguration) => {
        // console.log(studentConfiguration);
        vm.$refs.course_based.setCatalogs({
          careers: studentConfiguration.std_careers,
          branches: studentConfiguration.std_branches,
          studying_times: studentConfiguration.std_studying_times,
        });

        vm.$refs.preinscription_modal.set_catalogs({
          careers: studentConfiguration.std_careers,
          branches: studentConfiguration.std_branches,
          studying_times: studentConfiguration.std_studying_times,
        });

        if (studentConfiguration.std_users) {
          vm.$refs.professor_based.setUsers(studentConfiguration.std_users);
        }

        // setTimeout(() => {
        //   vm.$refs.course.map((c) => {
        //     c.init_dropdowns();
        //   });
        // }, 500);
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
};
</script>
